import React from "react";
import { ReactSVG } from "react-svg";

import financeIcon from "../../../assets/svg/mdi--cash-multiple.svg";

// Backend-ul nu are încă plăți / sold pentru elevi; tabul ține locul până
// există datele, ca structura profilului să fie deja cea finală.
export default function StudentFinanceTab() {
   return (
      <div className="studentsProfileUI__finance">
         <ReactSVG
            src={financeIcon}
            className="studentsProfileUI__financeIcon"
            wrapper="span"
         />
         <p className="studentsProfileUI__financeTitle">Finanțe</p>
         <p className="studentsProfileUI__financeText">
            Aici vor apărea plățile elevului, soldul și istoricul
            tranzacțiilor.
         </p>
      </div>
   );
}
